/******************************************************************************
 * This file was generated by langium-cli 3.3.0.
 * DO NOT EDIT MANUALLY!
 ******************************************************************************/

/* eslint-disable */
import type { AstNode, Reference, ReferenceInfo, TypeMetaData } from 'langium';
import { AbstractAstReflection } from 'langium';

export const IprotoTerminals = {
    WS: /\s+/,
    ML_COMMENT: /--[\s\S]*?--/,
    SL_COMMENT: /\/\/[^\n\r]*/,
    STRING: /"(\\.|[^"\\])*"/,
    NUMBER: /-?\d+(\.\d+)?/,
    BOOLEAN: /true|false/,
    IDENTIFIER: /[a-zA-Z][a-zA-Z0-9_]*/,
};

export type IprotoTerminalNames = keyof typeof IprotoTerminals;

export type IprotoKeywordNames = 
    | "#"
    | "("
    | ")"
    | "."
    | "..."
    | ":"
    | "::"
    | "<"
    | ">"
    | "?"
    | "["
    | "]"
    | "alias"
    | "as"
    | "boolean"
    | "directive"
    | "endpoint"
    | "enum"
    | "exception"
    | "field"
    | "float"
    | "int"
    | "module"
    | "on"
    | "scalar"
    | "string"
    | "struct"
    | "use"
    | "variant"
    | "with"
    | "{"
    | "}";

export type IprotoTokenNames = IprotoTerminalNames | IprotoKeywordNames;

export type Declaration = Alias | Directive | Endpoint | Enum | Exception | Import | Scalar | Struct;

export const Declaration = 'Declaration';

export function isDeclaration(item: unknown): item is Declaration {
    return reflection.isInstance(item, Declaration);
}

export type DirectiveLocation = 'endpoint' | 'enum' | 'exception' | 'field' | 'module' | 'scalar' | 'struct' | 'variant';

export function isDirectiveLocation(item: unknown): item is DirectiveLocation {
    return item === 'module' || item === 'scalar' || item === 'enum' || item === 'variant' || item === 'struct' || item === 'field' || item === 'exception' || item === 'endpoint';
}

export type Importable = Directive | Type;

export const Importable = 'Importable';

export function isImportable(item: unknown): item is Importable {
    return reflection.isInstance(item, Importable);
}

export type Keyword = 'alias' | 'as' | 'directive' | 'endpoint' | 'enum' | 'exception' | 'module' | 'on' | 'scalar' | 'struct' | 'use' | 'with';

export function isKeyword(item: unknown): item is Keyword {
    return item === 'module' || item === 'use' || item === 'as' || item === 'directive' || item === 'on' || item === 'scalar' || item === 'enum' || item === 'struct' || item === 'with' || item === 'alias' || item === 'endpoint' || item === 'exception';
}

export type LiteralValue = BooleanLiteral | NumberLiteral | StringLiteral;

export const LiteralValue = 'LiteralValue';

export function isLiteralValue(item: unknown): item is LiteralValue {
    return reflection.isInstance(item, LiteralValue);
}

export type LiteralValueType = 'boolean' | 'float' | 'int' | 'string';

export function isLiteralValueType(item: unknown): item is LiteralValueType {
    return item === 'int' || item === 'float' || item === 'boolean' || item === 'string';
}

export type RegularDeclarationName = DirectiveLocation | string;

export function isRegularDeclarationName(item: unknown): item is RegularDeclarationName {
    return isDirectiveLocation(item) || (typeof item === 'string' && (/[a-zA-Z][a-zA-Z0-9_]*/.test(item)));
}

export type RegularName = DirectiveLocation | Keyword | LiteralValueType | string;

export function isRegularName(item: unknown): item is RegularName {
    return isLiteralValueType(item) || isDirectiveLocation(item) || isKeyword(item) || (typeof item === 'string' && (/[a-zA-Z][a-zA-Z0-9_]*/.test(item)));
}

export type Type = Alias | Enum | Scalar | Struct;

export const Type = 'Type';

export function isType(item: unknown): item is Type {
    return reflection.isInstance(item, Type);
}

export interface Alias extends AstNode {
    readonly $container: File;
    readonly $type: 'Alias';
    name: RegularDeclarationName;
    type: ReferenceType;
}

export const Alias = 'Alias';

export function isAlias(item: unknown): item is Alias {
    return reflection.isInstance(item, Alias);
}

export interface BooleanLiteral extends AstNode {
    readonly $container: ReferenceDirectiveArgument | ReferenceTypeOption;
    readonly $type: 'BooleanLiteral';
    value: boolean;
}

export const BooleanLiteral = 'BooleanLiteral';

export function isBooleanLiteral(item: unknown): item is BooleanLiteral {
    return reflection.isInstance(item, BooleanLiteral);
}

export interface Directive extends AstNode {
    readonly $container: File;
    readonly $type: 'Directive';
    locations: Array<DirectiveLocation>;
    name: RegularDeclarationName;
    parameters: Array<DirectiveParameter>;
}

export const Directive = 'Directive';

export function isDirective(item: unknown): item is Directive {
    return reflection.isInstance(item, Directive);
}

export interface DirectiveParameter extends AstNode {
    readonly $container: Directive;
    readonly $type: 'DirectiveParameter';
    name: RegularName;
    optional: boolean;
    type: LiteralValueType;
}

export const DirectiveParameter = 'DirectiveParameter';

export function isDirectiveParameter(item: unknown): item is DirectiveParameter {
    return reflection.isInstance(item, DirectiveParameter);
}

export interface Endpoint extends AstNode {
    readonly $container: File;
    readonly $type: 'Endpoint';
    directives: Array<ReferenceDirective>;
    input?: ReferenceType;
    name: RegularName;
    output?: ReferenceType;
}

export const Endpoint = 'Endpoint';

export function isEndpoint(item: unknown): item is Endpoint {
    return reflection.isInstance(item, Endpoint);
}

export interface Enum extends AstNode {
    readonly $container: File;
    readonly $type: 'Enum';
    directives: Array<ReferenceDirective>;
    members: Array<EnumMember>;
    name: RegularDeclarationName;
}

export const Enum = 'Enum';

export function isEnum(item: unknown): item is Enum {
    return reflection.isInstance(item, Enum);
}

export interface EnumMember extends AstNode {
    readonly $container: Enum;
    readonly $type: 'EnumMember';
    directives: Array<ReferenceDirective>;
    name: RegularName;
}

export const EnumMember = 'EnumMember';

export function isEnumMember(item: unknown): item is EnumMember {
    return reflection.isInstance(item, EnumMember);
}

export interface Exception extends AstNode {
    readonly $container: File;
    readonly $type: 'Exception';
    directives: Array<ReferenceDirective>;
    fields: Array<Field>;
    name: RegularDeclarationName;
}

export const Exception = 'Exception';

export function isException(item: unknown): item is Exception {
    return reflection.isInstance(item, Exception);
}

export interface Field extends AstNode {
    readonly $container: Exception | Struct;
    readonly $type: 'Field';
    directives: Array<ReferenceDirective>;
    name: RegularName;
    type: ReferenceType;
}

export const Field = 'Field';

export function isField(item: unknown): item is Field {
    return reflection.isInstance(item, Field);
}

export interface File extends AstNode {
    readonly $type: 'File';
    declaraions: Array<Declaration>;
    module: Module;
}

export const File = 'File';

export function isFile(item: unknown): item is File {
    return reflection.isInstance(item, File);
}

export interface Import extends AstNode {
    readonly $container: File;
    readonly $type: 'Import';
    members: Array<ImportMember>;
    target: Reference<Module>;
}

export const Import = 'Import';

export function isImport(item: unknown): item is Import {
    return reflection.isInstance(item, Import);
}

export interface ImportMember extends AstNode {
    readonly $container: Import;
    readonly $type: 'ImportMember';
    name?: RegularDeclarationName;
    target: Reference<Importable>;
}

export const ImportMember = 'ImportMember';

export function isImportMember(item: unknown): item is ImportMember {
    return reflection.isInstance(item, ImportMember);
}

export interface Module extends AstNode {
    readonly $container: File;
    readonly $type: 'Module';
    directives: Array<ReferenceDirective>;
    name: RegularDeclarationName;
}

export const Module = 'Module';

export function isModule(item: unknown): item is Module {
    return reflection.isInstance(item, Module);
}

export interface NumberLiteral extends AstNode {
    readonly $container: ReferenceDirectiveArgument | ReferenceTypeOption;
    readonly $type: 'NumberLiteral';
    value: string;
}

export const NumberLiteral = 'NumberLiteral';

export function isNumberLiteral(item: unknown): item is NumberLiteral {
    return reflection.isInstance(item, NumberLiteral);
}

export interface ReferenceDirective extends AstNode {
    readonly $container: Endpoint | Enum | EnumMember | Exception | Field | Module | Scalar | Struct;
    readonly $type: 'ReferenceDirective';
    arguments: Array<ReferenceDirectiveArgument>;
    target: Reference<Directive>;
}

export const ReferenceDirective = 'ReferenceDirective';

export function isReferenceDirective(item: unknown): item is ReferenceDirective {
    return reflection.isInstance(item, ReferenceDirective);
}

export interface ReferenceDirectiveArgument extends AstNode {
    readonly $container: ReferenceDirective;
    readonly $type: 'ReferenceDirectiveArgument';
    target: Reference<DirectiveParameter>;
    value?: LiteralValue;
}

export const ReferenceDirectiveArgument = 'ReferenceDirectiveArgument';

export function isReferenceDirectiveArgument(item: unknown): item is ReferenceDirectiveArgument {
    return reflection.isInstance(item, ReferenceDirectiveArgument);
}

export interface ReferenceType extends AstNode {
    readonly $container: Alias | Endpoint | Field | ReferenceType | Struct;
    readonly $type: 'ReferenceType';
    arguments: Array<ReferenceType>;
    options: Array<ReferenceTypeOption>;
    target: Reference<Type>;
}

export const ReferenceType = 'ReferenceType';

export function isReferenceType(item: unknown): item is ReferenceType {
    return reflection.isInstance(item, ReferenceType);
}

export interface ReferenceTypeOption extends AstNode {
    readonly $container: ReferenceType;
    readonly $type: 'ReferenceTypeOption';
    target: Reference<ScalarOption>;
    value?: LiteralValue;
}

export const ReferenceTypeOption = 'ReferenceTypeOption';

export function isReferenceTypeOption(item: unknown): item is ReferenceTypeOption {
    return reflection.isInstance(item, ReferenceTypeOption);
}

export interface Scalar extends AstNode {
    readonly $container: File;
    readonly $type: 'Scalar';
    directives: Array<ReferenceDirective>;
    ellipsis: boolean;
    name: RegularDeclarationName;
    options: Array<ScalarOption>;
    parameters: Array<ScalarParameter>;
}

export const Scalar = 'Scalar';

export function isScalar(item: unknown): item is Scalar {
    return reflection.isInstance(item, Scalar);
}

export interface ScalarOption extends AstNode {
    readonly $container: Scalar;
    readonly $type: 'ScalarOption';
    name: RegularName;
    type: LiteralValueType;
}

export const ScalarOption = 'ScalarOption';

export function isScalarOption(item: unknown): item is ScalarOption {
    return reflection.isInstance(item, ScalarOption);
}

export interface ScalarParameter extends AstNode {
    readonly $container: Scalar;
    readonly $type: 'ScalarParameter';
    name: RegularDeclarationName;
}

export const ScalarParameter = 'ScalarParameter';

export function isScalarParameter(item: unknown): item is ScalarParameter {
    return reflection.isInstance(item, ScalarParameter);
}

export interface StringLiteral extends AstNode {
    readonly $container: ReferenceDirectiveArgument | ReferenceTypeOption;
    readonly $type: 'StringLiteral';
    value: string;
}

export const StringLiteral = 'StringLiteral';

export function isStringLiteral(item: unknown): item is StringLiteral {
    return reflection.isInstance(item, StringLiteral);
}

export interface Struct extends AstNode {
    readonly $container: File;
    readonly $type: 'Struct';
    directives: Array<ReferenceDirective>;
    fields: Array<Field>;
    mixins: Array<ReferenceType>;
    name: RegularDeclarationName;
}

export const Struct = 'Struct';

export function isStruct(item: unknown): item is Struct {
    return reflection.isInstance(item, Struct);
}

export type IprotoAstType = {
    Alias: Alias
    BooleanLiteral: BooleanLiteral
    Declaration: Declaration
    Directive: Directive
    DirectiveParameter: DirectiveParameter
    Endpoint: Endpoint
    Enum: Enum
    EnumMember: EnumMember
    Exception: Exception
    Field: Field
    File: File
    Import: Import
    ImportMember: ImportMember
    Importable: Importable
    LiteralValue: LiteralValue
    Module: Module
    NumberLiteral: NumberLiteral
    ReferenceDirective: ReferenceDirective
    ReferenceDirectiveArgument: ReferenceDirectiveArgument
    ReferenceType: ReferenceType
    ReferenceTypeOption: ReferenceTypeOption
    Scalar: Scalar
    ScalarOption: ScalarOption
    ScalarParameter: ScalarParameter
    StringLiteral: StringLiteral
    Struct: Struct
    Type: Type
}

export class IprotoAstReflection extends AbstractAstReflection {

    getAllTypes(): string[] {
        return [Alias, BooleanLiteral, Declaration, Directive, DirectiveParameter, Endpoint, Enum, EnumMember, Exception, Field, File, Import, ImportMember, Importable, LiteralValue, Module, NumberLiteral, ReferenceDirective, ReferenceDirectiveArgument, ReferenceType, ReferenceTypeOption, Scalar, ScalarOption, ScalarParameter, StringLiteral, Struct, Type];
    }

    protected override computeIsSubtype(subtype: string, supertype: string): boolean {
        switch (subtype) {
            case Alias:
            case Enum:
            case Scalar:
            case Struct: {
                return this.isSubtype(Declaration, supertype) || this.isSubtype(Type, supertype);
            }
            case BooleanLiteral:
            case NumberLiteral:
            case StringLiteral: {
                return this.isSubtype(LiteralValue, supertype);
            }
            case Directive: {
                return this.isSubtype(Declaration, supertype) || this.isSubtype(Importable, supertype);
            }
            case Endpoint:
            case Exception:
            case Import: {
                return this.isSubtype(Declaration, supertype);
            }
            case Type: {
                return this.isSubtype(Importable, supertype);
            }
            default: {
                return false;
            }
        }
    }

    getReferenceType(refInfo: ReferenceInfo): string {
        const referenceId = `${refInfo.container.$type}:${refInfo.property}`;
        switch (referenceId) {
            case 'Import:target': {
                return Module;
            }
            case 'ImportMember:target': {
                return Importable;
            }
            case 'ReferenceDirective:target': {
                return Directive;
            }
            case 'ReferenceDirectiveArgument:target': {
                return DirectiveParameter;
            }
            case 'ReferenceType:target': {
                return Type;
            }
            case 'ReferenceTypeOption:target': {
                return ScalarOption;
            }
            default: {
                throw new Error(`${referenceId} is not a valid reference id.`);
            }
        }
    }

    getTypeMetaData(type: string): TypeMetaData {
        switch (type) {
            case Alias: {
                return {
                    name: Alias,
                    properties: [
                        { name: 'name' },
                        { name: 'type' }
                    ]
                };
            }
            case BooleanLiteral: {
                return {
                    name: BooleanLiteral,
                    properties: [
                        { name: 'value', defaultValue: false }
                    ]
                };
            }
            case Directive: {
                return {
                    name: Directive,
                    properties: [
                        { name: 'locations', defaultValue: [] },
                        { name: 'name' },
                        { name: 'parameters', defaultValue: [] }
                    ]
                };
            }
            case DirectiveParameter: {
                return {
                    name: DirectiveParameter,
                    properties: [
                        { name: 'name' },
                        { name: 'optional', defaultValue: false },
                        { name: 'type' }
                    ]
                };
            }
            case Endpoint: {
                return {
                    name: Endpoint,
                    properties: [
                        { name: 'directives', defaultValue: [] },
                        { name: 'input' },
                        { name: 'name' },
                        { name: 'output' }
                    ]
                };
            }
            case Enum: {
                return {
                    name: Enum,
                    properties: [
                        { name: 'directives', defaultValue: [] },
                        { name: 'members', defaultValue: [] },
                        { name: 'name' }
                    ]
                };
            }
            case EnumMember: {
                return {
                    name: EnumMember,
                    properties: [
                        { name: 'directives', defaultValue: [] },
                        { name: 'name' }
                    ]
                };
            }
            case Exception: {
                return {
                    name: Exception,
                    properties: [
                        { name: 'directives', defaultValue: [] },
                        { name: 'fields', defaultValue: [] },
                        { name: 'name' }
                    ]
                };
            }
            case Field: {
                return {
                    name: Field,
                    properties: [
                        { name: 'directives', defaultValue: [] },
                        { name: 'name' },
                        { name: 'type' }
                    ]
                };
            }
            case File: {
                return {
                    name: File,
                    properties: [
                        { name: 'declaraions', defaultValue: [] },
                        { name: 'module' }
                    ]
                };
            }
            case Import: {
                return {
                    name: Import,
                    properties: [
                        { name: 'members', defaultValue: [] },
                        { name: 'target' }
                    ]
                };
            }
            case ImportMember: {
                return {
                    name: ImportMember,
                    properties: [
                        { name: 'name' },
                        { name: 'target' }
                    ]
                };
            }
            case Module: {
                return {
                    name: Module,
                    properties: [
                        { name: 'directives', defaultValue: [] },
                        { name: 'name' }
                    ]
                };
            }
            case NumberLiteral: {
                return {
                    name: NumberLiteral,
                    properties: [
                        { name: 'value' }
                    ]
                };
            }
            case ReferenceDirective: {
                return {
                    name: ReferenceDirective,
                    properties: [
                        { name: 'arguments', defaultValue: [] },
                        { name: 'target' }
                    ]
                };
            }
            case ReferenceDirectiveArgument: {
                return {
                    name: ReferenceDirectiveArgument,
                    properties: [
                        { name: 'target' },
                        { name: 'value' }
                    ]
                };
            }
            case ReferenceType: {
                return {
                    name: ReferenceType,
                    properties: [
                        { name: 'arguments', defaultValue: [] },
                        { name: 'options', defaultValue: [] },
                        { name: 'target' }
                    ]
                };
            }
            case ReferenceTypeOption: {
                return {
                    name: ReferenceTypeOption,
                    properties: [
                        { name: 'target' },
                        { name: 'value' }
                    ]
                };
            }
            case Scalar: {
                return {
                    name: Scalar,
                    properties: [
                        { name: 'directives', defaultValue: [] },
                        { name: 'ellipsis', defaultValue: false },
                        { name: 'name' },
                        { name: 'options', defaultValue: [] },
                        { name: 'parameters', defaultValue: [] }
                    ]
                };
            }
            case ScalarOption: {
                return {
                    name: ScalarOption,
                    properties: [
                        { name: 'name' },
                        { name: 'type' }
                    ]
                };
            }
            case ScalarParameter: {
                return {
                    name: ScalarParameter,
                    properties: [
                        { name: 'name' }
                    ]
                };
            }
            case StringLiteral: {
                return {
                    name: StringLiteral,
                    properties: [
                        { name: 'value' }
                    ]
                };
            }
            case Struct: {
                return {
                    name: Struct,
                    properties: [
                        { name: 'directives', defaultValue: [] },
                        { name: 'fields', defaultValue: [] },
                        { name: 'mixins', defaultValue: [] },
                        { name: 'name' }
                    ]
                };
            }
            default: {
                return {
                    name: type,
                    properties: []
                };
            }
        }
    }
}

export const reflection = new IprotoAstReflection();
